import React, { useMemo, useRef, useState } from "react";
import FilterIcon from "assets/images/filter-icon.svg";
import FilterIconEmpty from "assets/icons/courses/filter-icon.svg";
import AngleUp from "assets/icons/courses/angle-up.svg";
import Checkbox from "common/components/Checkbox";
import { useOutsideAlerter } from "features/game/components/Pagination/CustomSelect";
import "./HeaderFilterCourses.scss";

interface Props {
  onChangeLevel?: (type: "hard" | "ease" | "medium") => void;
  levels?: any;
}

const FilterCourses = ({ onChangeLevel, levels }: Props) => {
  const [isActiveFilter, setIsActiveFilter] = useState(false);
  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef, () => {
    setIsActiveFilter(false);
  });
  const isChecked = useMemo(() => {
    if (levels.ease || levels.medium || levels.hard) {
      return true;
    }
    return false;
  }, [levels]);
  return (
    <div style={{ position: "relative" }} ref={wrapperRef}>
      <div className="header-filter-filter-block" onClick={() => setIsActiveFilter(true)}>
        <img
          src={isChecked ? FilterIcon : FilterIconEmpty}
          style={{ width: isChecked ? 19 : 19, height: isChecked ? 20 : 20 }}
        />
      </div>
      {isActiveFilter && (
        <div className="header-filter-content">
          <div className="header-filter-content-top" onClick={() => setIsActiveFilter(false)}>
            <span className="header-filter-content-label">בחר דרגת קושי</span>
            <img src={AngleUp} />
          </div>
          <div className="header-filter-content-bottom">
            <div className="header-filter-block-checkbox">
              <Checkbox
                label="ראשוני"
                onClick={() => onChangeLevel && onChangeLevel("ease")}
                checked={levels?.ease}
              />
            </div>
            <div className="header-filter-block-checkbox">
              <Checkbox
                label="בסיסי"
                onClick={() => onChangeLevel && onChangeLevel("medium")}
                checked={levels?.medium}
              />
            </div>
            <div className="header-filter-block-checkbox" style={{ marginBottom: 0 }}>
              <Checkbox
                label="מתקדם"
                onClick={() => onChangeLevel && onChangeLevel("hard")}
                checked={levels?.hard}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default FilterCourses;
